export default function (tz) {
    return (impl, box) => ({
        fromJsObject: (parser) => (obj) => {
            return parser(obj);
        },
        convertRelative(tb, tzFrom, tzTo) {
            return tb.convertTimezones(tzFrom, { keepLocalTime: true }).convertTimezones(tzTo);
        },
        convertRelativeToUtc(tb, tzFrom) {
            return tb.convertTimezones(tzFrom, { keepLocalTime: true }).convertTimezones('utc');
        },
        convertRelativeString(time, tzFrom, tzTo) {
            return impl.pipe(impl.fromTimeString(time), impl.convertTimezonesC(tzFrom, { keepLocalTime: true }), impl.convertTimezonesC(tzTo));
        },
        convertRelativeStringToUtc(time, tzFrom) {
            return impl.pipe(impl.fromTimeString(time), impl.convertTimezonesC(tzFrom, { keepLocalTime: true }), impl.convertTimezonesC('UTC'));
        },
        createDateTime(dateTime = null) {
            if (!dateTime) {
                return box.now();
            }
            return box.fromFormat(dateTime.value, dateTime.format);
        },
        withTimeZoneCreateDateTime() {
            return () => {
                return box.convertTimezones('Europe/Copenhagen');
            };
        },
        exec(tb) {
            return tb.exec();
        },
        withTimeZone(tb) {
            const dateTime = this.withTimeZoneCreateDateTime()();
            this.exec(dateTime);
            return tb.convertTimezones(tz);
        },
        dateTimeFromFormatInTimeZone(dateTime, format) {
            return this.withTimeZone(box.fromFormat(dateTime, format));
        },
        isValidDateTime(tb) {
            return tb.valid().exec();
        },
        nowInTimeZone(timeZone = null, opts = { keepLocalTime: true }) {
            if (timeZone) {
                return box.now().convertTimezones(timeZone, opts);
            }
            return box.now().convertTimezones(tz, opts);
        },
        relativeNowInTimeZone(tzFrom = null, tzTo = null) {
            const timeZoneFrom = tzFrom ? tzFrom : tz;
            const timeZoneTo = tzTo ? tzTo : tz;
            return box.now().convertTimezones(timeZoneFrom, { keepLocalTime: true }).convertTimezones(timeZoneTo);
        },
    });
}
